import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { RefundModel } from '../models/Refund';

const REFUND_ORDER_URL = `${MOKA_GOAUTH_SERVICE}/order/v4/refund-orders`;

async function refundOrder({ refund, outletId }: { refund: RefundModel.RefundPayload; outletId: number }): Promise<RefundModel.Response> {
  const { data } = await axios.post(
    REFUND_ORDER_URL,
    { refund },
    {
      headers: { OUTLET_ID: outletId },
      withCredentials: true,
    },
  );

  return data;
}

export { REFUND_ORDER_URL, refundOrder };
